import { render, staticRenderFns } from "./ZboxClosuresTable.vue?vue&type=template&id=d24caed6&scoped=true&"
import script from "./ZboxClosuresTable.vue?vue&type=script&lang=js&"
export * from "./ZboxClosuresTable.vue?vue&type=script&lang=js&"
import style0 from "./ZboxClosuresTable.vue?vue&type=style&index=0&id=d24caed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24caed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
